import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import { format, subDays } from 'date-fns';
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { parseTime } from '@/filters/index';
import { cookRequestParams } from '@/common/request';
import tableMixin from './table-mixin';
import { getVideoProjectList } from '@/api/dashboard/playturbo.js';
import { GrantTypeLabelOptions, GrantTypeLabel } from '@/common/permission';
import { formatTimeWithoutMs } from '@com/utils/data-format';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { statusOptions } from '@/common/permission';
import { projectCreatedPageOptions } from '@/config/project';
var videoProjectTypeOptions = [{
  label: '视频剪辑',
  value: 'normal'
}, {
  label: '快速替换',
  value: 'simple'
}];

var dayTime = 1000 * 60 * 60 * 24;

var defaultQuery = {
  page: 1,
  page_size: 50,
  time: [format(subDays(new Date() - dayTime * 30, 1), 'YYYY-MM-DD'), format(subDays(new Date(), 1), 'YYYY-MM-DD')],
  adv_ids: [],
  adv_id: '',
  adv_search_type: 'adv_name',
  project_name: '',
  project_ids: '',
  skin_name: '',
  project_types: [],
  grant_types: [],
  created_pages: [],
  template_name: '',
  template_ids: '',
  export: 0
};

export default {
  mixins: [searchMixin, tableMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination
  },
  data: function data() {
    return {
      query: _extends({}, defaultQuery),

      list: [],
      listLoading: false,

      tableConfig: {
        'row-key': '_id'
      },

      pagination: {
        total: 0
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      var list = {
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            startPlaceholder: '创建开始时间',
            endPlaceholder: '创建结束时间',
            pickerOptions: {
              disabledDate: function disabledDate(time) {
                return time.getTime() > Date.now();
              },

              shortcuts: [{
                text: '最近三天',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: this.$t('form.pastWeek'),
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近半个月',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                  picker.$emit('pick', [start, end]);
                }
              }]
            }
          }
        },
        grant_types: {
          type: 'select',
          prop: 'grant_types',
          params: {
            placeholder: '请选择订阅类型',
            options: GrantTypeLabelOptions
          }
        },
        adv_search_type: {
          type: 'select',
          prop: 'adv_search_type',
          params: {
            options: [{
              label: '广告主名称',
              value: 'adv_name'
            }, {
              label: '广告主ID',
              value: 'adv_id'
            }]
          }
        },
        adv_ids: {
          prop: 'adv_ids',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            class: 'search-filter-select'
          }
        },
        adv_id: {
          type: 'input',
          prop: 'adv_id',
          params: {
            clearable: true,
            placeholder: '请输入广告主ID'
          }
        },
        created_pages: {
          type: 'select',
          prop: 'created_pages',
          params: {
            clearable: true,
            placeholder: '请选择项目创建页面',
            options: projectCreatedPageOptions.filter(function (item) {
              return item.value !== 'person-template';
            })
          }
        },
        // template_search_type: {
        //   type: 'select',
        //   prop: 'template_search_type',
        //   params: {
        //     options: [
        //       {
        //         label: '模板名称',
        //         value: 'template_name',
        //       },
        //       {
        //         label: '模板id',
        //         value: 'template_ids',
        //       },
        //     ],
        //   },
        // },
        template_name: {
          type: 'input',
          prop: 'template_name',
          params: {
            clearable: true,
            placeholder: '请输入模板名称'
          }
        },
        template_ids: {
          type: 'input',
          prop: 'template_ids',
          params: {
            clearable: true,
            placeholder: '请输入模板id'
          }
        },
        project_types: {
          type: 'select',
          prop: 'project_types',
          params: {
            clearable: true,
            options: videoProjectTypeOptions,
            placeholder: '请选择项目类型'
          }
        },
        project_ids: {
          type: 'input',
          prop: 'project_ids',
          params: {
            clearable: true,
            placeholder: '请输入项目id'
          }
        },
        project_name: {
          type: 'input',
          prop: 'project_name',
          params: {
            clearable: true,
            placeholder: '请输入项目名称'
          }
        }
        // 广告主/id
      };if (this.query.adv_search_type === 'adv_name') {
        delete list.adv_id;
      } else {
        delete list.adv_ids;
      }
      return list;
    },
    tableColumnConfig: function tableColumnConfig() {
      var tableList = [{
        label: '项目创建时间',
        prop: 'created_time',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return parseTime(row.created_time, '{y}-{m}-{d}');
          }
        }
      }, {
        label: '订阅类型',
        prop: 'plan_grant_type',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return GrantTypeLabel[row.plan_grant_type];
          }
        }
      }, {
        label: '状态',
        prop: 'plan_status',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return statusOptions[row.plan_status] || row.plan_status;
          }
        }
      }, {
        label: '广告主Id',
        prop: 'adv_id'
      }, {
        label: '广告主名称',
        prop: 'adv_name'
      }, {
        label: '创建页面',
        prop: 'created_page',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            return useValueExchangeLabel(row.created_page, projectCreatedPageOptions) || '-';
          }
        }
      }, {
        label: '模板Id',
        prop: 'template_id'
      }, {
        label: '模板名称',
        prop: 'template_name'
      }, {
        label: '项目类型',
        prop: 'project_type',
        params: {
          innerHTML: function innerHTML(_ref5) {
            var row = _ref5.row;

            return useValueExchangeLabel(row.project_type, videoProjectTypeOptions);
          }
        }
      }, {
        label: '项目id',
        prop: 'project_id'
      }, {
        label: '项目名称',
        prop: 'project_name'
      }, {
        label: '项目制作时长',
        prop: 'production_duration',
        params: {
          innerHTML: function innerHTML(_ref6) {
            var row = _ref6.row;

            return formatTimeWithoutMs(row.production_duration);
          }
        }
      }, {
        label: '导出视频数',
        prop: 'video_count'
      }, {
        label: '各比例导出数',
        prop: 'ratio_video_count',
        params: {
          innerHTML: function innerHTML(_ref7) {
            var row = _ref7.row;

            if (row.ratio_video_count) {
              var str = '';
              for (var key in row.ratio_video_count) {
                str += '<p>' + key + ': ' + row.ratio_video_count[key] + '</p>';
              }
              return str;
            }
            return '-';
          }
        }
      }, {
        label: '各语言导出数',
        prop: 'lang_video_count',
        slot: 'lang-count-cell',
        params: {
          innerHTML: function innerHTML(_ref8) {
            var row = _ref8.row;

            if (row.lang_video_count) {
              var str = '';
              for (var key in row.lang_video_count) {
                str += '<p>' + (key || '原语言') + ': ' + row.lang_video_count[key] + '</p>';
              }
              return str;
            }
            return '-';
          }
        }
      }];

      return tableList;
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.dispatch();
    },
    'query.adv_search_type': function queryAdv_search_type(val) {
      if (val === 'adv_name') {
        this.query.adv_id = '';
      } else {
        this.query.adv_ids = [];
      }
    }
  },

  mounted: function mounted() {
    this.dispatch();
  },


  methods: {
    exportSheet: function exportSheet() {
      var params = _extends({}, this.getParamsData(this.query), {
        export: 1
      });
      downloadWithNewWindow(v2Host + '/dashboard/playturbo/video-project-list?' + qs.stringify(_extends({}, cookRequestParams(params))));
    },
    handleSortChange: function handleSortChange(_ref9) {
      var column = _ref9.column,
          prop = _ref9.prop,
          order = _ref9.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    dispatch: function dispatch() {
      this.getMaterialReport();
    },
    getMaterialReport: function getMaterialReport(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, sum, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return getVideoProjectList(_this.getParamsData(params));

              case 4:
                res = _context.sent;
                sum = _.get(res, 'data.data.sum', []);
                list = sum.concat(_.get(res, 'data.data.list') || []);

                _this.list = list;
                _this.pagination.total = _.get(res, 'data.data.total') || 0;
                _this.listLoading = false;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 12]]);
      }))();
    },
    getParamsData: function getParamsData(params) {
      var innerParams = _.omit(_.cloneDeep(params || this.query), ['adv_search_type', 'adv_id']);
      if (!_.isEmpty(innerParams.push_download_time)) {
        innerParams.download_push_start_date = innerParams.push_download_time[0];
        innerParams.download_push_end_date = innerParams.push_download_time[1];
        innerParams = _.omit(innerParams, ['push_download_time']);
      }
      innerParams.adv_ids = this.query.adv_search_type === 'adv_name' ? this.query.adv_ids : [this.query.adv_id];
      return innerParams;
    },
    handleColumnFilterChange: function handleColumnFilterChange() {
      this.query.page = 1;
      this.handleSearch(this.query);
    },
    resetSearch: function resetSearch() {
      this.handleResetSearch();
    }
  }
};